// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1117":"7fe0432d","4044":"8b01d234","4198":"936a71c4"}[chunkId] + ".chunk.css";
};